module.exports = __webpack_public_path__ + "img/call-dail.934e2075.svg";